/* SKY eight-tile mobile carousel: one 86vw card at a time, 3.5s hold,
   shine sweeps 900ms before each advance, seamless loop via a duplicated
   aria-hidden set. Touch stops it instantly; it resumes 2s after release
   from wherever the customer left it. Desktop is a static grid - untouched. */
(() => {
  if (window.skyTilesInit) return; window.skyTilesInit = true;
  const init = () => {
    const root = document.querySelector('.sky-t8');
    if (!root || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const vp = root.querySelector('.sky-t8__viewport');
    const btn = root.querySelector('.sky-t8__pp');
    const items = [...vp.querySelectorAll('.sky-t8__item')];
    const n = items.length;  /* clones removed: mobile is a single-set snap rail */
    const mq = matchMedia('(max-width: 749px)');
    let holdT = null, shineT = null, idleT = null, userPaused = false, inView = true;
    const step = () => items[1].offsetLeft - items[0].offsetLeft;
    const idx = () => Math.round(vp.scrollLeft / step());
    const clearTimers = () => {
      clearTimeout(holdT); clearTimeout(shineT); clearTimeout(idleT);
      holdT = shineT = idleT = null;
      items.forEach((el) => el.classList.remove('is-shine'));
    };
    const schedule = () => {
      clearTimers();
      if (userPaused || !inView || !mq.matches) return;
      shineT = setTimeout(() => { const i = idx(); if (items[i]) items[i].classList.add('is-shine'); }, 2600);
      holdT = setTimeout(advance, 3500);
    };
    const advance = () => {
      items.forEach((el) => el.classList.remove('is-shine'));
      const next = idx() + 1;
      vp.scrollTo({ left: next >= n ? 0 : next * step(), behavior: 'smooth' });
      setTimeout(() => { schedule(); }, 700);
    };
    vp.addEventListener('pointerdown', () => {
      clearTimers();
      vp.style.scrollBehavior = 'auto'; vp.scrollLeft = vp.scrollLeft; vp.style.scrollBehavior = '';
    });
    const idle = () => { clearTimeout(idleT); idleT = setTimeout(schedule, 2000); };
    vp.addEventListener('pointerup', idle);
    vp.addEventListener('pointercancel', idle);
    vp.addEventListener('touchend', idle);
    root.addEventListener('focusin', clearTimers);
    root.addEventListener('focusout', () => requestAnimationFrame(() => { if (!root.contains(document.activeElement)) schedule(); }));
    if (btn) btn.addEventListener('click', () => {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', userPaused);
      btn.textContent = userPaused ? 'Play' : 'Pause';
      userPaused ? clearTimers() : schedule();
    });
    new IntersectionObserver((es) => { inView = es[0].isIntersecting; inView ? schedule() : clearTimers(); }).observe(root);
    mq.addEventListener('change', () => (mq.matches ? schedule() : clearTimers()));
    schedule();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
